'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutStepTwoComponent = exports.rentalCheckoutStepTwoComponent = {
    template: require('./rental-checkout-step-two.html'),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        onProductsRentedSucces: '&'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", "Enums", function controller(rentalProductsService, Enums) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.confirmOrder = confirmOrder;
        vm.recommendedRentalProducts;
        vm.recommendedPortalProducts;
        vm.suggestedRentalProducts;
        vm.suggestedPortalProducts;

        function init() {
            filterRelatedProducts();
        }

        function filterRelatedProducts() {
            vm.recommendedRentalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'RENTAL';
            });
            vm.recommendedPortalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'PORTALPRODUCT';
            });
            vm.suggestedRentalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'RENTAL';
            });
            vm.suggestedPortalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'PORTALPRODUCT';
            });
        }

        function confirmOrder() {
            rentalProductsService.orderRentedProducts(vm.rentalProduct, [].concat(vm.recommendedRentalProducts, vm.recommendedPortalProducts), [].concat(vm.suggestedRentalProducts, vm.suggestedPortalProducts), vm.contactInfo, vm.deliveryInfo).then(function (result) {
                vm.onProductsRentedSucces({
                    $event: result
                });
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/rental-checkout-step-two.js
// module id = 1002
// module chunks = 0